<template lang="pug">
.video-panel
  video.client(ref="client-video" autoplay playsInline)
  video.self(v-show="showSelf" ref="self-video" autoplay muted playsInline)
  .button-group(v-if="showControls")
    .control-media
      aiq-button.grey-btn(@click="onMute(true)")
        mute-icon(v-if="!muted")
        unmute-icon(v-else)
      aiq-button.grey-btn(@click="onCameraOnOff(true)")
        video-on-icon(v-if="!cameraOff")
        video-off-icon(v-else)
      aiq-button.red-btn(@click="onLeaveVideoCall(true)")
        hang-up-icon
  .size-btn
    aiq-button(
      :class="{'grey-small-btn': size === 'small', 'grey-small-btn-rotated': size !== 'small'}"
      @click="onSizeChange")
      scale-icon
</template>

<script>
import get from 'lodash/get';
import { joinRoom, leaveRoom, mute } from '../lib/twilio';
import VideoOnIcon from '../assets/video/video.vue';
import VideoOffIcon from '../assets/video/video-off.vue';
import MuteIcon from '../assets/video/mute.vue';
import UnmuteIcon from '../assets/video/unmute.vue';
import HangUpIcon from '../assets/video/end-video.vue';
import ScaleIcon from '../assets/video/arrow-video.vue';

let mediaRoom = null;
export default {
  name: 'aiqOneOnOneVideoPanel',
  components: {
    VideoOnIcon,
    VideoOffIcon,
    MuteIcon,
    UnmuteIcon,
    HangUpIcon,
    ScaleIcon,
  },
  props: {
    config: {
      type: Object,
      default: () => ({
        video: null,
        audio: null,
        room: null,
      }),
    },
    debug: {
      type: Boolean,
      default: false,
    },
    token: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'small',
    },
    showSelf: {
      type: Boolean,
      default: true,
    },
    showControls: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      muted: false,
      cameraOff: false,
    };
  },
  mounted() {
    if (!this.validateConfig(this.config)) {
      return this.$emit('error', new Error('incorrect config'));
    }

    this.connectionChangeCb = this.connectionChangeCb.bind(this);
    return this.initializeVideoCall();
  },
  methods: {
    validateConfig(config) {
      if (!get(config, 'room.name')) {
        return false;
      }
      return true;
    },

    async initializeVideoCall() {
      mediaRoom = await joinRoom(
        this.token,
        {
          name: this.config.room.name,
          video: this.config.video,
          audio: this.config.audio,
        },
        this.$refs['self-video'],
        this.$refs['client-video'],
        this.debug,
        this.connectionChangeCb,
      );
    },

    async onLeaveVideoCall(fromUI) {
      if (fromUI) {
        this.$emit('ui-event', { event: 'click', name: 'hang-up' });
      }

      if (mediaRoom) {
        leaveRoom(mediaRoom);
        mediaRoom = null;
      }

      this.$refs['self-video'].srcObject = null;
      this.$refs['client-video'].srcObject = null;

      this.$emit('end');
    },

    connectionChangeCb(identity, ev) {
      this.$emit('event', { name: ev, identity });
    },

    onMute(fromUI) {
      if (fromUI) {
        this.$emit('ui-event', { event: 'click', name: 'mute' });
      }
      this.muted = !(this.muted);
      mute(mediaRoom, this.muted, 'audio');
    },

    onCameraOnOff(fromUI) {
      if (fromUI) {
        this.$emit('ui-event', { event: 'click', name: 'camera' });
      }
      this.cameraOff = !(this.cameraOff);
      mute(mediaRoom, this.cameraOff, 'video');
    },

    onSizeChange() {
      this.$emit('size-change');
    },
  },
};
</script>

<style lang="scss" scoped>
.video-panel {
  position: relative;
  width: 100%;
  height: 100%;
  max-height: inherit;
  max-width: inherit;

  video.client {
    background: black
  }
  
   video.self {
        margin-top: 8px;
        margin-left: 8px;
        border-radius: 4px;
        box-shadow: 0px 0px 2px 2px rgba(39,49,63,0.42);
    }

    .control-media button, .size-btn button {
        background-color: rgba(39,49,63,0.42);
    }

}

video {
  width: 100%;
  height: 100%;
  max-height: inherit;
  max-width: inherit;
}

.self {
  position: absolute;
  width: 30%;
  height: initial;
  left: 0px;
  top: 0px;
}

.size-btn {
  position: absolute;
  top: 8px;
  right: 8px;
}

.video-btn {
  width: 52px;
  height: 52px;
  background: grey;
  border: 0px;
  stroke: #ffffff;
  border-radius: 30px;
  padding: 10px 10px;
}

.button-group {
  display: flex;
  justify-content: space-around;
  padding: 16px 0px;
  width: 100%;
  bottom: 0px;
  position: absolute;
}

.grey-btn {
  @extend .video-btn;
  background: grey;
}

.grey-small-btn {
  @extend .grey-btn;
  width: 32px;
  height: 32px;
  padding: 0px;
}

.grey-small-btn-rotated {
  @extend .grey-small-btn;
  transform: rotate(180deg);
}

.red-btn {
  @extend .video-btn;
  background: red !important;
  opacity: 0.65;
}

</style>
